import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const header = theme => css`
  position: sticky;
  top: 0;
  background-color: ${theme.color.monochrome.white};
  z-index: 1;
`

const heading = theme => css`
  position: relative;
  border-bottom: 1px solid ${theme.color.info[50]};
  padding: ${rem(23)} 0 ${rem(20)} ${rem(20)};

  @media only screen and (min-width: ${theme.breakpoints.tabletBreakpoint}) {
    display: flex;
    justify-content: center;
    padding-left: 0;
  }
`

const logo = css`
  height: ${rem(32)};

  img {
    height: 100%;
    width: auto;
  }
`

const login = theme => css`
  font-size: ${theme.fontSize.large};
  color: ${theme.color.info[900]};
  position: absolute;
  right: ${rem(20)};
  top: 50%;
  transform: translateY(-50%);

  span {
    display: none;
  }

  @media only screen and (min-width: 420px) {
    span {
      display: inline;
    }
  }

  @media only screen and (min-width: ${theme.breakpoints.tabletBreakpoint}) {
    right: ${rem(39)};
  }
`

export const styles = {
  header,
  heading,
  logo,
  login,
}
